import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import CategoryScreen from '../../../components/categoryScreen';
import CategoryScreenBg from '../../../images/ComponentImages/categoryScreenBackground.png';
import RoundScreen from '../../../components/roundScreen';

export default function Page10({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Run 3 - 4 Sets'
				isNumberd={true}
				rounds={[
					[
						{header: 'Type', value: 'ALPHA'},
						{header: 'C.C.M.R’s', value: 'STANDARD BENCH PRESS'},
						{header: 'REPS', value: '3 - 6'},
						{header: 'WEIGHT LEVEL', value: 'Heavy'},
					],
				]}
			/>
			<p style={style.takeABreakTextStyle()}>Take a 1 - 2 minute break</p>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
